<div class="info-navigation">
  <!-- PA navigation -->
  <ng-container *ngIf="!isInternal">
    <div class="info-navigation__left">
      <a routerLink="/invitations"
        ><button
          [ngClass]="{ active: type == 'invitations' }"
          class="info-navigation__left__button info-navigation__left__button--invitation"
        >
          <span class="material-icons">mail</span>Invitations
        </button></a
      >
      <a routerLink="/proposals"
        ><button
          [ngClass]="{ active: type == 'proposals' }"
          class="info-navigation__left__button info-navigation__left__button--proposal"
        >
          <span class="material-icons">note_alt</span>Pending
        </button></a
      >

      <a routerLink="/active"
        ><button
          [ngClass]="{ active: type == 'active' }"
          class="info-navigation__left__button info-navigation__left__button--active"
        >
          <span class="material-icons">room_service</span>Active
        </button></a
      >

      <button
        *ngIf="showClearSearchButton"
        class="info-navigation__left__button info-navigation__left__clear-button"
        (click)="clearSearch()"
      >
        <span class="material-icons">cancel</span>Clear Search
      </button>
    </div>
    <div class="info-navigation__right">
      <button routerLink="/project-history">
        <span class="material-icons">work_history</span>Project History
      </button>
    </div>
  </ng-container>

  <!-- Internal navigation -->
  <ng-container *ngIf="isInternal">
    <div class="info-navigation__left">
      <a routerLink="/internal/dashboard"
        ><button
          [ngClass]="{ active: type == 'internal-dashboard' }"
          class="info-navigation__left__button"
        >
          <span class="material-icons">admin_panel_settings</span>Dashboard
        </button></a
      >
    </div>
  </ng-container>
</div>
